<template>
    <div v-loading="isBusy">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="item">
                <item-select
                    ref="itemSelect"
                    class="w-100"
                    v-model="form.item"
                    placeholder="Search Items"
                    clearable
                    :url="searchUrl"
                ></item-select>
            </el-form-item>
            <el-form-item prop="outgoing_number_id" v-if="isOutgoingNumberVisible">
                <el-select
                    class="w-100"
                    v-model="form.outgoing_number_id"
                    :clearable="true"
                    placeholder="Select Outgoing Number"
                >
                    <el-option
                        v-for="item in outgoingNumbers"
                        :key="item.id"
                        :label="formatOutgoingNumber(item)"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div>
            <button class="btn btn-purple" @click="store">Add</button>
        </div>
    </div>
</template>

<script>
  import ValidatorMixin from "../../../mixins/validator";
  import ItemSelect from "./item-select";

  export default {
    components: {
      ItemSelect,
    },

    props: {
      searchUrl: String,
      storeUrl: String,
      sendList: Object,
      outgoingNumbers: Array,
    },

    data() {
      return {
        isBusy: false,
        form: {
          item: null,
          outgoing_number_id: null,
        },
        rules: {
          item: [{validator: this.fieldExternalValidator}],
          outgoing_number_id: [{validator: this.fieldExternalValidator}],
        },
        errors: {},
      };
    },

    computed: {
      /**
       * @return {boolean}
       */
      isOutgoingNumberVisible() {
        return _.get(this.form.item, 'type') === 'contact';
      },
    },

    watch: {
      //
    },

    methods: {
      /**
       * @return {Object}
       */
      getForm() {
        const form = {
          send_list_id: this.sendList.id,
          item: _.get(this.form, 'item.id'),
        };
        if (_.get(this.form, 'item.type') === 'contact') {
          form.outgoing_number_id = this.form.outgoing_number_id;
        }

        return _.assign({}, form, {_method: 'POST'});
      },

      /**
       * @return {undefined}
       */
      store() {
        this.isBusy = true;
        axios.post(this.storeUrl, this.getForm())
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .finally(() => this.isBusy = false);
      },

      /**
       * @param {Object} data
       * @param {String|undefined} message
       * @return {undefined}
       */
      storeSuccess({data: {message}}) {
        this.$refs.itemSelect.clear();
        message && this.$message.success(message);
        this.$emit('created');
      },

      /**
       * @param {Object} error
       */
      handleErrorResponse({response: {data: {errors, message}, status}}) {
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);
        } else if (status === 428 && message) {
          this.$message.warning(message);
        } else if (message && _.isString(message)) {
          this.$message.error(message);
        }
      },

      /**
       * @return {undefined}
       */
      resetForm() {
        this.form = _.assign({}, {send_list_id: this.form.send_list_id});
      },

      /**
       * @param {String} title
       * @param {String} phone_number
       * @return {String}
       */
      formatOutgoingNumber({title = '', phone_number}) {
        return title
          ? `${title} (${phone_number})`
          : `(${phone_number})`;
      },
    },

    mounted() {
      //
    },

    mixins: [
      ValidatorMixin
    ]
  }
</script>

